import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import mediator, { ACTIONS } from 'mediator';
import metrics from 'lib/common/metrics';
import find from 'lodash/find';
import features from '../lib/common/features';
import queryString from 'query-string';

class LevelSelector extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedLevel: this.props.selectedLevel ? this.props.selectedLevel.selector : null,
    };

    this.handleReset = this.handleReset.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    mediator.subscribe(ACTIONS.LEVEL_PRESELECTED, level => {
      this.setState({ selectedLevel: level });
    });

    let params = queryString.parse(window.location.search);
    if (params && params.layer) {
      this.setState({ selectedLevel: params.layer });
    }/* else if (!this.props.selectedLevel) {
      this.setState({ selectedLevel: this.props.levels[0].label });
    }*/
  }

  componentDidUpdate(prevProps, prevState) {
    let selectedLevel = this.state.selectedLevel;
    if (prevState.selectedLevel !== selectedLevel) {
      mediator.publish(ACTIONS.LEVEL_SELECTED, selectedLevel);
    }
  }

  handleReset() {
    metrics.action('Selected section', 'All sections');
    this.setState({ selectedLevel: null });
  }

  handleChange(e) {
    let val = e.currentTarget.value;

    let bestAvailableSections = features.getOption(
      'bestAvailableLink',
      'bestAvailableSections'
    );
    let bestAvailableUrl = features.getOption('bestAvailableLink', 'url');

    let isBestAvailableSection = find(bestAvailableSections, item => {
      return val === item;
    });

    if (val) {
      metrics.action('Selected level', val);
      this.setState({
        selectedLevel: val
      });
    }

    if (isBestAvailableSection && isBestAvailableSection.length) {
      window.location = `${bestAvailableUrl}${this.props.performanceId}`;
    }
  }

  render() {
    return (
      <div className="syos-key syos-key--optional">
        <ul className="syos-key__list">
          <li className="syos-key__list__item">
            <input
              className="syos-key__option-input"
              type="radio"
              name="radio-level"
              id="radio-level-any"
              value=""
              checked={this.state.selectedLevel === null ? true : false}
              onChange={this.handleReset}
              aria-label="All levels"
            />
            <label className="syos-key__option-label" htmlFor="radio-level-any">
              All sections
            </label>
          </li>
          {this.props.levels.map((level, idx) => {
            return (
              <li className="syos-key__list__item" key={idx}>
                <label
                  className={classnames({
                    'syos-key__option-label': true,
                    'syos-key__option-label--disabled': !level.isAvailable
                  })}
                >
                  <input
                    type="radio"
                    className="syos-key__option-input"
                    onChange={this.handleChange}
                    name="radio-level"
                    id={`radio-level-${idx}`}
                    value={level.el.id}
                    disabled={!level.isAvailable}
                    checked={this.state.selectedLevel === level.label}
                  />
                  {level.label}
                </label>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

LevelSelector.propTypes = {
  levels: PropTypes.arrayOf(PropTypes.object),
  selectedLevel: PropTypes.object,
  performanceId: PropTypes.number
};

export default LevelSelector;



// WEBPACK FOOTER //
// ./src/javascripts/components/LevelSelector.js